(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
 class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  //class ProductRecommendations2 extends HTMLElement {
  //  constructor() {
  //    super();

  //    const handleIntersection = (entries, observer) => {
  //      if (!entries[0].isIntersecting) return;
  //      observer.unobserve(this);

  //      fetch(this.dataset.url)
  //        .then((response) => response.text())
  //        .then((text) => {
  //          const html = document.createElement('div');
  //          html.innerHTML = text;
  //          const recommendations = html.querySelector('product-recommendations2');
  //          if (recommendations && recommendations.innerHTML.trim().length) {
  //            this.innerHTML = recommendations.innerHTML;
  //          }
  //        })
  //        .catch((e) => {
  //          console.error(e);
  //        });
  //    };

  //    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  //  }
  //}

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);
  //customElements.define('product-recommendations2', ProductRecommendations2);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Función para inicializar las tarjetas de productos
  window.initializeProductCards = function(container = document) {
    console.log('Inicializando product-cards...');
    
    // Seleccionar todos los botones de variante en el contenedor
    const variantButtons = container.querySelectorAll('.variant-button');
    variantButtons.forEach(button => {
      // Agregar event listener para el clic
      button.addEventListener('click', function(event) {
        // IMPORTANTE: Prevenir la navegación en contexto de búsqueda
        const isInSearchResults = button.closest('predictive-search') !== null || 
                                 button.closest('.template-search-container') !== null;
        if (isInSearchResults) {
          console.log('Click en botón de variante dentro de resultados de búsqueda - Previniendo navegación');
          event.preventDefault();
          event.stopPropagation();
        }
        
        const cardWrapper = this.closest('.card-wrapper');
        const variantId = this.getAttribute('data-variant-id');
        const variantPrice = this.getAttribute('data-variant-price');
        const variantCompareAtPrice = this.getAttribute('data-variant-compare-at-price');
        const variantDiscount = this.getAttribute('data-variant-discount');
        const variantTitle = this.innerText.trim();
        
        // Actualizar la URL del producto
        const productHandle = cardWrapper.getAttribute('data-product-handle');
        const newUrl = `https://belenus.cl/products/${productHandle}?variant=${variantId}`;
        
        // Actualizar enlaces solo si no estamos en resultados de búsqueda
        if (!isInSearchResults) {
          const imageLink = cardWrapper.querySelector('.card__inner a');
          const titleLink = cardWrapper.querySelector('.card__title a');
          if (imageLink) imageLink.setAttribute('href', newUrl);
          if (titleLink) titleLink.setAttribute('href', newUrl);
        }
        
        // Actualizar precios
        const priceElement = cardWrapper.querySelector('.current-price');
        if (priceElement) priceElement.innerText = variantPrice;
        
        // Actualizar precio comparativo
        const compareAtPriceElement = cardWrapper.querySelector('.compare-at-price');
        if (compareAtPriceElement) {
          if (variantCompareAtPrice && variantCompareAtPrice !== 'null' && variantCompareAtPrice !== '0') {
            compareAtPriceElement.innerText = variantCompareAtPrice;
            compareAtPriceElement.style.display = 'inline-block';
          } else {
            compareAtPriceElement.style.display = 'none';
          }
        }
        
        // Actualizar descuento
        const discountElement = cardWrapper.querySelector('.discount-badge');
        if (discountElement) {
          if (variantDiscount && variantDiscount !== 'null' && variantDiscount !== '0') {
            discountElement.innerText = variantDiscount + '%';
            discountElement.style.display = 'inline-block';
          } else {
            discountElement.style.display = 'none';
          }
        }
        
        // Actualizar botón seleccionado
        cardWrapper.querySelectorAll('.variant-button').forEach(btn => {
          btn.classList.remove('selected');
        });
        this.classList.add('selected');
        
        // Actualizar cuotas
        window.updateInstallments(cardWrapper, variantPrice, variantTitle);
      });
    });
    
    // Seleccionar automáticamente la variante de 6 sesiones en cada tarjeta
    const wrappers = container.querySelectorAll ? container.querySelectorAll('.card-wrapper') : [container];
    wrappers.forEach(wrapper => {
      if (!wrapper.classList.contains('card-wrapper')) return;
      
      // Verificar si estamos en resultados de búsqueda
      const isInSearchResults = wrapper.closest('predictive-search') !== null || 
                               wrapper.closest('.template-search-container') !== null;
      
      // Buscar el botón de 6 sesiones (exactamente "6 sesiones", no "6 sesiones cliente nuevo")
      const sixSessionsButton = Array.from(wrapper.querySelectorAll('.variant-button')).find(button => {
        const buttonText = button.innerText.trim();
        return buttonText === "6 sesiones" || (buttonText.includes("6 sesiones") && !buttonText.includes("cliente nuevo"));
      });
      
      // Si se encuentra, simulamos un clic en él
      if (sixSessionsButton && !sixSessionsButton.classList.contains('selected')) {
        console.log('Seleccionando automáticamente variante de 6 sesiones');
        
        // Si estamos en resultados de búsqueda, actualizamos manualmente sin simular click
        if (isInSearchResults) {
          console.log('Estamos en resultados de búsqueda, actualizando manualmente sin simular click');
          
          // Marcar como seleccionado
          wrapper.querySelectorAll('.variant-button').forEach(btn => {
            btn.classList.remove('selected');
          });
          sixSessionsButton.classList.add('selected');
          
          // Actualizar precio
          const variantPrice = sixSessionsButton.getAttribute('data-variant-price');
          const variantTitle = sixSessionsButton.innerText.trim();
          const priceElement = wrapper.querySelector('.current-price');
          if (priceElement) priceElement.innerText = variantPrice;
          
          // Actualizar cuotas directamente
          window.updateInstallments(wrapper, variantPrice, variantTitle);
        } else {
          // Si no estamos en búsqueda, podemos simular el click normalmente
          const clickEvent = new MouseEvent('click', {
            bubbles: false, // Cambiado a false para evitar propagación
            cancelable: true,
            view: window
          });
          sixSessionsButton.dispatchEvent(clickEvent);
        }
      }
    });
  };
  
  // Función para actualizar las cuotas
  window.updateInstallments = function(cardWrapper, price, variantTitle) {
    console.log('Actualizando cuotas para:', variantTitle);
    const installmentElement = cardWrapper.querySelector('.installments-message');
    const installmentPriceElement = installmentElement ? installmentElement.querySelector('.installment-price') : null;
    
    if (!installmentElement || !installmentPriceElement) {
      console.log('No se encontró el elemento de cuotas');
      return;
    }
    
    // Verificar si debe mostrar cuotas
    if (variantTitle.includes("1ª sesión cliente nuevo") || 
        variantTitle.includes("6 sesiones cliente nuevo") || 
        variantTitle.includes("3 sesiones cliente nuevo") || 
        variantTitle.includes("15 Créditos Belenus") || 
        variantTitle.includes("30 Créditos Belenus")) {
      installmentElement.classList.add('installments-hidden');
      installmentPriceElement.innerText = '';
      return;
    }
    
    // Mostrar cuotas
    installmentElement.classList.remove('installments-hidden');
    
    // Normalizar el precio
    let priceNumber;
    if (typeof price === 'string') {
      if (price.includes('$') || price.includes('.')) {
        priceNumber = parseInt(price.replace(/[^0-9]/g, ''), 10);
      } else {
        priceNumber = parseInt(price, 10);
        if (priceNumber > 1000000) {
          priceNumber = priceNumber / 100;
        }
      }
    } else {
      console.log('Formato de precio no reconocido:', price);
      return;
    }
    
    // Calcular cuotas
    const installmentAmount = Math.round(priceNumber / 6);
    
    // Formatear el monto
    const formattedInstallmentAmount = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP'
    }).format(installmentAmount);
    
    // Actualizar el texto
    installmentPriceElement.innerText = formattedInstallmentAmount;
    console.log('Cuotas actualizadas:', formattedInstallmentAmount);
  };
  
  // Función para actualizar todas las cuotas en la página
  window.updateAllInstallments = function() {
    console.log('=== ACTUALIZANDO TODAS LAS CUOTAS ===');
    
    // Actualizar todas las cuotas
    const wrappers = document.querySelectorAll('.card-wrapper');
    console.log(`Encontrados ${wrappers.length} product-cards para actualizar`);
    
    let actualizados = 0;
    wrappers.forEach(wrapper => {
      try {
        // Obtener el botón seleccionado
        const selectedButton = wrapper.querySelector('.variant-button.selected');
        if (!selectedButton) {
          console.log('No hay botón seleccionado en:', wrapper.getAttribute('data-product-handle') || wrapper.getAttribute('data-product'));
          return;
        }
        
        // Obtener datos del botón
        const variantPrice = selectedButton.getAttribute('data-variant-price');
        const variantTitle = selectedButton.innerText.trim();
        
        // Actualizar cuotas
        window.updateInstallments(wrapper, variantPrice, variantTitle);
        actualizados++;
      } catch (error) {
        console.error('Error al actualizar cuotas:', error);
      }
    });
    
    console.log(`=== ACTUALIZACIÓN COMPLETADA: ${actualizados}/${wrappers.length} ACTUALIZADOS ===`);
  };
  
  // SOLUCIÓN DIRECTA: Función para forzar la actualización de cuotas en todos los productos
  window.forceUpdateAllInstallments = function() {
    console.log('=== FORZANDO ACTUALIZACIÓN DE TODAS LAS CUOTAS ===');
    
    // Función para actualizar las cuotas de un producto
    function updateInstallment(wrapper) {
      // Obtener el botón seleccionado
      const selectedButton = wrapper.querySelector('.variant-button.selected');
      if (!selectedButton) {
        console.log('No hay botón seleccionado en:', wrapper.getAttribute('data-product-handle') || wrapper.getAttribute('data-product'));
        return;
      }
      
      // Obtener datos del botón
      const variantPrice = selectedButton.getAttribute('data-variant-price');
      const variantTitle = selectedButton.innerText.trim();
      
      // Obtener elementos de cuotas
      const installmentElement = wrapper.querySelector('.installments-message');
      const installmentPriceElement = installmentElement ? installmentElement.querySelector('.installment-price') : null;
      
      if (!installmentElement || !installmentPriceElement) {
        console.log('No se encontró el elemento de cuotas en:', wrapper.getAttribute('data-product-handle') || wrapper.getAttribute('data-product'));
        return;
      }
      
      // Verificar si debe mostrar cuotas
      if (variantTitle.includes("1ª sesión cliente nuevo") || 
          variantTitle.includes("6 sesiones cliente nuevo") || 
          variantTitle.includes("3 sesiones cliente nuevo") || 
          variantTitle.includes("15 Créditos Belenus") || 
          variantTitle.includes("30 Créditos Belenus")) {
        installmentElement.classList.add('installments-hidden');
        installmentPriceElement.innerText = '';
        return;
      }
      
      // Mostrar cuotas
      installmentElement.classList.remove('installments-hidden');
      
      // Normalizar el precio
      let priceNumber;
      if (typeof variantPrice === 'string') {
        if (variantPrice.includes('$') || variantPrice.includes('.')) {
          priceNumber = parseInt(variantPrice.replace(/[^0-9]/g, ''), 10);
        } else {
          priceNumber = parseInt(variantPrice, 10);
          if (priceNumber > 1000000) {
            priceNumber = priceNumber / 100;
          }
        }
      } else {
        console.log('Formato de precio no reconocido:', variantPrice);
        return;
      }
      
      // Calcular cuotas
      const installmentAmount = Math.round(priceNumber / 6);
      
      // Formatear el monto
      const formattedInstallmentAmount = new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP'
      }).format(installmentAmount);
      
      // Actualizar el texto
      installmentPriceElement.innerText = formattedInstallmentAmount;
      console.log('Cuotas actualizadas para:', wrapper.getAttribute('data-product-handle') || wrapper.getAttribute('data-product'), '- Valor:', formattedInstallmentAmount);
    }
    
    // Actualizar todas las cuotas
    const wrappers = document.querySelectorAll('.card-wrapper');
    console.log(`Encontrados ${wrappers.length} product-cards para actualizar`);
    
    let actualizados = 0;
    wrappers.forEach(wrapper => {
      try {
        updateInstallment(wrapper);
        actualizados++;
      } catch (error) {
        console.error('Error al actualizar cuotas:', error);
      }
    });
    
    console.log(`=== ACTUALIZACIÓN COMPLETADA: ${actualizados}/${wrappers.length} ACTUALIZADOS ===`);
  };
  
  // Agregar un MutationObserver para detectar cuando se agregan nuevos productos al DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i];
          if (node.nodeType === 1 && (node.classList.contains('card-wrapper') || node.querySelector('.card-wrapper'))) {
            console.log('Detectado nuevo producto agregado al DOM');
            
            // Inicializar el nuevo producto
            window.initializeProductCards(node.classList.contains('card-wrapper') ? node : node.querySelector('.card-wrapper'));
            
            // IMPORTANTE: Forzar actualización de cuotas después de un tiempo
            setTimeout(function() {
              window.forceUpdateAllInstallments();
            }, 500);
            
            // DOBLE VERIFICACIÓN: Actualizar nuevamente después de un tiempo más largo
            setTimeout(function() {
              window.forceUpdateAllInstallments();
            }, 1500);
          }
        }
      }
    });
  });
  
  // Iniciar la observación del DOM
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Ejecutar la inicialización y actualización después de que se cargue la página
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOMContentLoaded: Inicializando product-cards...');
    window.initializeProductCards();
    
    // Primera actualización
    setTimeout(function() {
      window.forceUpdateAllInstallments();
    }, 500);
    
    // Segunda actualización para asegurar
    setTimeout(function() {
      window.forceUpdateAllInstallments();
    }, 1500);
  });
  
  // Ejecutar la inicialización y actualización si el DOM ya está cargado
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    console.log('DOM ya cargado: Inicializando product-cards...');
    window.initializeProductCards();
    
    // Primera actualización
    setTimeout(function() {
      window.forceUpdateAllInstallments();
    }, 500);
    
    // Segunda actualización para asegurar
    setTimeout(function() {
      window.forceUpdateAllInstallments();
    }, 1500);
  }
  
  // HACK FINAL: Actualizar cuotas cada vez que se hace scroll
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      window.forceUpdateAllInstallments();
    }, 500);
  });
  
  // HACK FINAL 2: Actualizar cuotas cada 3 segundos durante los primeros 15 segundos
  let updateCount = 0;
  const intervalId = setInterval(function() {
    window.forceUpdateAllInstallments();
    updateCount++;
    if (updateCount >= 5) {
      clearInterval(intervalId);
    }
  }, 3000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formulario-inscripcion"]) return;
  try {
    
  function submitForm() {
    const formData = {
      name: document.getElementById('name').value,
      rut: document.getElementById('rut').value,
      email: document.getElementById('email').value,
      phone: document.getElementById('phone').value,
      service: document.getElementById('service').value
    };

    // Validar datos antes de enviar
    if (!validarRUT(formData.rut) || !validarCorreo(formData.email)) {
      alert('Por favor, verifica que los datos ingresados son correctos.');
      return;
    }

    fetch('https://belenus-shopify-app-2kc8s.ondigitalocean.app/api/formulario-shopify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Respuesta del servidor:', data);
      document.getElementById('inscriptionForm').style.display = 'none';
      document.getElementById('confirmationMessage').style.display = 'block';
    })
    .catch(error => {
      console.error('Error al enviar los datos:', error);
    });
  }

  function validarRUT(rut) {
    // Añade aquí la validación del RUT
    return true; // Simulando una validación exitosa
  }

  function validarCorreo(email) {
    // Simples chequeos de formato de email
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function formatAndValidateRut(input) {
    let value = input.value.replace(/\D/g, '');
    // Formatea el RUT con puntos y guión
    const rut = value.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, ".") + '-' + value.slice(-1);
    input.value = rut;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
	constructor() {
	super();
}

connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.header1 = document.querySelector('.header-wrapper--under-menu')
	this.header_wrapper = document.querySelector('.header-wrapper');
	this.header__offcanvas_menu = document.querySelector('.header__offcanvas-menu');
	this.predictiveSearch = this.querySelector('predictive-search');
	this.headerBounds = {};
	this.currentScrollTop = 0;

	this.onScrollHandler = this.onScroll.bind(this);

	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
}

disconnectedCallback() {
	window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
});

	observer.observe(this.header);
}

onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
		this.predictiveSearch.onFocusOut();
		this.predictiveSearch.onBlur();
	} 
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
	} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
}

	hide() {
		if(this.header1){
			this.header.classList.add('shopify-section-header-fixed-hidden', 'shopify-section-header-sticky', 'animate');
		}
		else {
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
		}
	// this.closeSearchModal();
}

reveal() {
	if(this.header1){
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-fixed-hidden');
			this.header_wrapper.classList.add('header-wrapper--under-menu-full');
		}
	else {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
	}
	this.header__offcanvas_menu.classList.add('header__offcanvas_menu-reveal')
}

reset() {
	if(this.header1){
		this.header.classList.remove('shopify-section-header-fixed-hidden', 'shopify-section-header-sticky', 'animate');
		this.header_wrapper.classList.remove('header-wrapper--under-menu-full');
	}
	else {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}
	this.header__offcanvas_menu.classList.remove('header__offcanvas_menu-reveal')

}

closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure?.close());
}

// closeSearchModal() {
// 	this.searchModal = this.searchModal || this.header.querySelector('details-modal');
// 	this.searchModal.close(false);
// }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
 class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  //class ProductRecommendations2 extends HTMLElement {
  //  constructor() {
  //    super();

  //    const handleIntersection = (entries, observer) => {
  //      if (!entries[0].isIntersecting) return;
  //      observer.unobserve(this);

  //      fetch(this.dataset.url)
  //        .then((response) => response.text())
  //        .then((text) => {
  //          const html = document.createElement('div');
  //          html.innerHTML = text;
  //          const recommendations = html.querySelector('product-recommendations2');
  //          if (recommendations && recommendations.innerHTML.trim().length) {
  //            this.innerHTML = recommendations.innerHTML;
  //          }
  //        })
  //        .catch((e) => {
  //          console.error(e);
  //        });
  //    };

  //    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  //  }
  //}

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);
  //customElements.define('product-recommendations2', ProductRecommendations2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
const productRecommendationsSlider = () => {
    console.log("productRecommendationsSlider initialized");
    $('.js-product-recommendations').each(function (index, parent) {
        console.log("Processing recommendation slider:", index);
        let parentId = `#${$(parent).attr('id')}`;

        let carousel = document
            .querySelector(parentId)
            .querySelector(`.js-swiper-product-recommendations`);

        let scrollBar = document
            .querySelector(parentId)
            .querySelector(`.js-product-recommendations-swiper-scrollbar`);

        let prev = document
            .querySelector(parentId)
            .querySelector(`.js-product-recommendations-arrow-prev`);

        let next = document
            .querySelector(parentId)
            .querySelector(`.js-product-recommendations-arrow-next`);

        let swiperCarousel = new Swiper(carousel, {
            slidesPerView: 3,
            spaceBetween: 8,
            scrollbar: {
                el: scrollBar,
                draggable: true,
            },
            navigation: {
                prevEl: prev,
                nextEl: next,
            },
            breakpoints: {
                0: { slidesPerView: 1 },
                920: { slidesPerView: 2 },
                1100: { slidesPerView: 3 },
                1200: { slidesPerView: 2 },
                1300: { slidesPerView: 3 },
                1500: { slidesPerView: 3 },
                1800: { slidesPerView: 3 },
            },
        });

        if (
            $('.js-product-recommendations-arrow-prev').hasClass(
                'swiper-button-lock'
            ) ||
            $('.js-product-recommendations-arrow-next').hasClass(
                'swiper-button-lock'
            )
        ) {
            $('.nav-tools').css('display', 'none');
        }
    });

    document.querySelectorAll('.variant-button').forEach(button => {
        console.log("Adding event listener to variant button:", button);
        button.addEventListener('click', selectVariant);
    });
};

class ProductRecommendations2 extends HTMLElement {
    constructor() {
        super();
        console.log("ProductRecommendations2 initialized");

        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector(
                        'product-recommendations2'
                    );
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                        productRecommendationsSlider();
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '0px 0px 200px 0px',
        }).observe(this);
    }
}

customElements.define('product-recommendations2', ProductRecommendations2);

document.addEventListener('shopify:section:load', function () {
    console.log("Shopify section load event triggered");
    productRecommendationsSlider();
});

  } catch(e) { console.error(e); }
})();
})();
